import React from 'react'
import { EmployerPage } from '../Pages/Employer/EmployerPage/EmployerPage'

function Employerpage() {
  return (
    <>
        <EmployerPage />
    </>
  )
}

export default Employerpage
